import { createSelector } from '@reduxjs/toolkit';
import { pageDataService } from 'common';

import { IFamilyState } from './familyState';

export const getOtherFamilyMembers = createSelector(
  (state: IFamilyState) => state.familyMembers,
  (members) => {
    return members?.filter((member) => !pageDataService.isCurrentUserByUserId(member.puid));
  }
);

export const getCurrentFamilyMember = createSelector(
  (state: IFamilyState) => state.familyMembers,
  (members) => {
    return members?.find((member) => pageDataService.isCurrentUserByUserId(member.puid));
  }
);
